import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, share, switchMap } from 'rxjs/operators';

import { OneViewPermissionsService } from '../../shared/services/one-view-permissions/one-view-permissions.service';
import { OneViewPermissionsAction } from './one-view-permissions.action';

@Injectable()
export class OneViewPermissionsEffects {
  constructor(
    private actions$: Actions,
    private oneViewPermissionsService: OneViewPermissionsService,
  ) {}

  public getOneViewPermissions$ = createEffect(() =>
    this.actions$.pipe(
      ofType(OneViewPermissionsAction.getOneViewPermissions),
      switchMap(() =>
        this.oneViewPermissionsService.getViewPermissions().pipe(
          map((payload) => ({
            type: OneViewPermissionsAction.getOneViewPermissionsSuccess,
            payload,
          })),
          catchError((error) =>
            of({
              type: OneViewPermissionsAction.getOneViewPermissionsError,
              payload: error?.message || error,
            }),
          ),
        ),
      ),
      share(),
    ),
  );
}
